import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { PaymentMethod } from '../models';
import { PaymentMethodNew } from '../models/payment-method-new';
import { RequestType } from '../types';


@Injectable({
	providedIn: 'root'
})
export class PaymentMethodService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) { }

	getForDeposit(): Observable<PaymentMethod[]> {
		return this.httpClient
			.get<PaymentMethod[]>(`${this.appConfig.apiEndpoint}/v2/paymentMethod/deposit`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getAll(requestType: RequestType): Observable<PaymentMethodNew> {
		const url = `${this.appConfig.apiEndpoint}/new-core/payment-methods?requestType=${requestType}`;
		return this.httpClient
			.get<PaymentMethodNew>(url)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForFilter(requestType: RequestType): Observable<PaymentMethod[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/payment-methods/local?requestType=${requestType}`;
		return this.httpClient
			.get<PaymentMethod[]>(url)
			.pipe(
				map(res => {
					return res['data'];
				}));
	}
}
